import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.format)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["comma-number", _ctx.currentClass])
      }, _toDisplayString(_ctx.currentData), 3))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["comma-number", _ctx.currentClass])
      }, _toDisplayString(_ctx.format(_ctx.currentData)), 3))
}